module.exports = __webpack_public_path__ + "static/media/nelonen_logo_slogan.a8ab56e3.svg";